import { createFileRoute } from "@tanstack/react-router";
import { StocksPagePending } from "~/features/stocks/routing/stocks-page-pending";
import { warmSymbolShellFromListRoute } from "~/features/symbol/routing/warm-symbol-shell";
import { createSocialHeadMeta } from "~/lib/social-head";
import { STOCKS_SOCIAL_METADATA } from "~/lib/social-metadata";

export const Route = createFileRoute("/_app/stocks")({
  head: () => ({
    meta: createSocialHeadMeta(STOCKS_SOCIAL_METADATA),
  }),
  // Paint the page silhouette inside the live chrome the moment navigation
  // commits (no 1s default delay) while the lazy chunk loads.
  pendingComponent: StocksPagePending,
  pendingMs: 0,
  loader: ({ context, preload }) => {
    void import("~/features/stocks/stocks-route").then(
      ({ preloadStocksRoute }) => {
        void preloadStocksRoute(context);
      },
    );
    // Post-paint deferred (idle slice, 4s grace) — it never competes with the
    // stocks page's own first paint, and list→detail taps need the ~108 KB
    // symbol chunk resident before the click on touch devices with no hover
    // intent lead time.
    warmSymbolShellFromListRoute(preload);
  },
});
